/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS2Icon16Solid = forwardRef('MediaAudioVolumeS2Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.704 5 7.51 1.694a.9.9 0 0 1 1.49.68v11.252a.9.9 0 0 1-1.49.68L3.704 11H1.5A1.5 1.5 0 0 1 0 9.5v-3A1.5 1.5 0 0 1 1.5 5h2.204Z" }),
        React.createElement("path", { d: "M12.477 2.785a.875.875 0 0 1 1.238 0 7.375 7.375 0 0 1 0 10.43.875.875 0 1 1-1.238-1.238 5.626 5.626 0 0 0 0-7.954.875.875 0 0 1 0-1.238Z" }),
        React.createElement("path", { d: "M11.594 4.906a.875.875 0 1 0-1.238 1.238 2.626 2.626 0 0 1 0 3.712.875.875 0 1 0 1.238 1.238 4.377 4.377 0 0 0 0-6.188Z" })));
});
